import { ROUTES } from '@/app/routes';
import { $profile, type PanelRole } from '@/entities/profile-entity';
import { useUnit } from 'effector-react';
import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

interface ProtectedRouteProps extends PropsWithChildren {
	roles: PanelRole[];
}

export default function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
	const profile = useUnit($profile);

	if (!profile || profile.role === 'regwait' || !roles.includes(profile.role)) {
		return <Navigate to={ROUTES.myClients} replace />;
	}

	return children;
}
